import { addHours } from 'date-fns';

export const MAX_IDLE_HOURS = 24;

export type EntityStatus = 'enabled' | 'no_recent_data' | 'disabled';
export type ComputedStatus =
  | EntityStatus
  | 'checking'
  | 'failed'
  | 'disconnected'
  | 'needs_attention'
  | 'oauth_disconnected';
export interface StatusDetails {
  status: ComputedStatus;
  lastSeen?: number;
}

export const computeStatus = (isEnabled: boolean, lastSeenTimestamp: number) => {
  if (!isEnabled) {
    return 'disabled';
  }
  if (lastSeenTimestamp === 0) {
    return 'no_recent_data';
  }
  const now = new Date();
  const lastSeen = new Date(lastSeenTimestamp * 1000);
  if (addHours(lastSeen, MAX_IDLE_HOURS) > now) {
    return 'enabled';
  }
  return 'no_recent_data';
};

type OptionalStatusDetails = StatusDetails | undefined | null;

export function sortByLastSeen(a: OptionalStatusDetails, b: OptionalStatusDetails) {
  const lastSeenA = a?.lastSeen ?? 0;
  const lastSeenB = b?.lastSeen ?? 0;
  return lastSeenA - lastSeenB;
}

export function sortByStatus(a: OptionalStatusDetails, b: OptionalStatusDetails) {
  const statusA = statusWeight(a?.status);
  const statusB = statusWeight(b?.status);
  return statusA - statusB;
}

function statusWeight(status?: ComputedStatus) {
  const max = 10;
  if (status == null) {
    return max * -1;
  }
  if (status === 'enabled') {
    return max;
  }
  if (status === 'no_recent_data') {
    return max / 2;
  }
  return max / 4;
}
